<template>
  <Select
    v-model="selectValue"
    :id="id"
    :placeholder="placeholder"
    :withDefaultOption="withDefaultOption"
    :data="salesStatusOptions"
    :isLastPage="true"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import Select from '@/components/Select.vue';
import ItemSalesStatus from '@/store/modules/item-profile/models/item-sales-status.enum';

const salesStatusOptions = [
  {
    id: ItemSalesStatus.Minted,
    label: 'Coming soon',
  },
  {
    id: ItemSalesStatus.OnSale,
    label: 'Fixed-price sale',
  },
  {
    id: ItemSalesStatus.OnEnglishAuction,
    label: 'Auction sale',
  },
  {
    id: ItemSalesStatus.OnOffChainOfferAuction,
    label: 'Accepting offchain offers',
  },
];

export default defineComponent({
  name: 'ItemTypeSelect',

  props: {
    modelValue: {
      default: null,
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    withDefaultOption: {
      type: Boolean,
      default: false,
    },
    isFormElement: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Select,
  },

  emits: [
    'update:modelValue',
  ],

  setup(props, { emit }) {
    const selectValue = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit('update:modelValue', value);
      },
    });

    return {
      selectValue,
      salesStatusOptions,
    };
  },
});
</script>
